var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlankTag = function SvgBlankTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.508 8.2a1.81 1.81 0 0 0 1.818-1.8c0-.995-.814-1.8-1.818-1.8a1.81 1.81 0 0 0-1.819 1.8c0 .994.814 1.8 1.819 1.8z",
    stroke: "#004996",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.699 9.469 10.144 1h-9.09v9l8.554 8.469a1.834 1.834 0 0 0 2.572 0l6.519-6.453a1.79 1.79 0 0 0 0-2.547zM6.508 8.2c-1 0-1.818-.81-1.818-1.8s.818-1.8 1.818-1.8 1.818.81 1.818 1.8-.818 1.8-1.818 1.8z",
    fill: "#fff",
    stroke: "#004996",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgBlankTag;